var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description"},[_c('iframe',{ref:"iframe",attrs:{"frameborder":"0"}}),(_vm.iframeImageUrl)?_c('img',{ref:"img",staticClass:"qr-code-touchable-image",attrs:{"src":_vm.iframeImageUrl,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }